import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="benchmark"
export default class extends Controller {

  static outlets = ["unread-badge"]
  static targets = ["boldElement"]

  connect() {
  }

  async documentClick(event){
    if (this.hasElementTarget && this.boldElementTarget.classList.contains("link_not_bold")) {
      this.boldElementTarget.classList.remove("link_not_bold")
      this.unreadBadgeOutlets.forEach(elem => {
        elem.decreaseCounter()
      })
    }
    
    if(!this.element.classList.contains("docRead")){
      this.element.classList.add("docRead")
      this.element.classList.remove("link_not_bold")
      this.unreadBadgeOutlets.forEach(elem => {
        elem.decreaseCounter()
      })
    }
    
  }
}
